export default __webpack_public_path__ + "static/media/minus-light.b0ddb3d4.svg";